import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=c7c40130&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=c7c40130&scoped=true&lang=scss"
import style1 from "./dialog.vue?vue&type=style&index=1&id=c7c40130&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c40130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7c40130')) {
      api.createRecord('c7c40130', component.options)
    } else {
      api.reload('c7c40130', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=c7c40130&scoped=true", function () {
      api.rerender('c7c40130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/DC/dialog.vue"
export default component.exports